<template>
    <div>
        <input-group icon="fa fa-calendar">
            <v-select class="form-control"
                      v-model="valueModel"
    
                      :options="options"
                      :disabled="disabled"
                      :clearable="false"
    
                      label="label"
    
                      close-on-select
            />
        </input-group>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import InputGroup from "@core/Components/Inputs/InputGroup";
import VSelect from 'vue-select';

export default {
    name: "InflowPeriodPicker",
    
    components: {
        InputGroup,
        VSelect
    },
    
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    
    data() {
        return  {
            options: []
        }
    },
    
    computed: {
        ...mapState('journeyBuilder/reporting', [ 'inflowPeriodId' ]),
        
        valueModel: {
            get() {
                return this.options.find(o => o.id === this.inflowPeriodId);
            },
            set(value) {
                this.setInflowPeriodId(value && value.id);
            }
        }
    },

    async created() {
        try {
            this.options = await api.getStatisticsInflowPeriods();
            
            //Default to first option
            this.valueModel = this.options[0];
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    },
    
    methods: {
        ...mapMutations('journeyBuilder/reporting', [ 'setInflowPeriodId' ])
    }
}
</script>
